// taskIdInCharge (ticketReducer) e' la lista degli id dei task in carico separati da ';',
// per esempio "123;456;". Va letta come lista: un confronto su sottostringa da' in carico
// il task 23 quando lo e' il 123 [CSP-3810].
export const idTaskInCarico = (taskIdInCharge) => `${taskIdInCharge ?? ''}`.split(';').filter(Boolean);

export const isTaskInCarico = (taskIdInCharge, taskId) =>
  taskId != null && idTaskInCarico(taskIdInCharge).includes(String(taskId));
